import React, { useMemo } from 'react'
import { useState } from 'react'
import CommentModal from './CommentModal'
import ReportModal from './ReportModal'
import { useSelector } from 'react-redux'
import { selectAuthentication } from '../../redux/personaliseLessons/authenticationSlice'
import { selectLessonDetails } from '../../redux/personaliseLessons/lessonDetailsSlice'
import { selectCourseList } from '../../redux/personaliseLessons/courseListSlice'
import { toast } from 'react-toastify'
import { useEffect } from 'react'
import useWindowSize from '../../hooks/useWindowSize'


function LikeCommentViewReport ({ videoPlayerRef, showTimeLine, setShowTimeLine }) {

    const uid = useSelector(selectAuthentication)?.uid
    const lessonDetails = useSelector(selectLessonDetails)?.lesson_data
    const subject_name = useSelector(selectCourseList)?.courseName
    const totalDuration = videoPlayerRef.current ? videoPlayerRef.current.getDuration() : 0

    const [ showCommentModal, setShowCommentModal ] = useState(false)
    const [ showReportModal, setShowReportModal ] = useState(false)
    const [ randomDigit, setRandomDigit ] = useState(0)
    
    const { width } = useWindowSize()

    const startTime = lessonDetails?.start_time
    const stopTime = lessonDetails?.stop_time

    useEffect(() => {
        const randomNumber = Math.floor(50000 + Math.random()*10000)
        setRandomDigit(randomNumber/1000)
    }, [])

    const handleClick = () => {
        toast.success("Thank you for your feedback!")
    }

    const time = useMemo(() => {
        return Math.floor((stopTime - startTime)/60)
    }, [startTime, stopTime])

    const handleShowTimeLine = () => {
        if ((startTime === 0 && stopTime === totalDuration) || (startTime === 0 && stopTime === 0)){
            return
        }
        setShowTimeLine(prev => !prev)
    }

    const calculateWidth = (start, stop) => {
        const duration = stop - start
        return (duration / totalDuration) * 100
    }

    const timestampStyle = {
        width: `${calculateWidth(startTime, stopTime)}%`,
        left: `${(startTime/totalDuration)*100}%`
    }
    
    function formatSeconds(seconds) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const remainingSeconds = seconds % 60
    
        const formattedHours = hours < 10 ? `0${hours}` : hours
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes
        const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds
    
        let formattedTime = `${formattedMinutes}:${formattedSeconds}`
        if (hours > 0) {
            formattedTime = `${formattedHours}:${formattedTime}`
        }
    
        return formattedTime
    }
    console.log(startTime, stopTime, totalDuration)
    return (
        <>
            {(startTime !== 0 || stopTime !== totalDuration) && showTimeLine && <div className='px-4 lg:px-6 mb-4'>
                <div className='w-full bg-secondary_background px-5 py-4 rounded-xl flex items-center gap-2'>
                    <p className='text-xs font-medium text-white/50'>Personalised for you</p>
                    <div className='flex-1 rounded-xl bg-white h-1 relative flex items-center'>
                        <div className='absolute rounded-xl bg-[#54A3F5] top-0 bottom-0 left-0' style={timestampStyle}/>
                        <div className='w-2.5 h-2.5 bg-[#54A3F5] rounded-full absolute' style={{
                            left: `${(startTime/totalDuration)*100}%`
                        }} />
                        <div className='absolute text-[10px] font-medium text-[#54A3F5] top-2' style={{
                            left: `${((startTime/totalDuration)*100) - (width >= 1024 ? 1 : 3)}%`
                        }}>
                            {formatSeconds(startTime)}
                        </div>
                        <div className='w-2.5 h-2.5 bg-[#54A3F5] rounded-full absolute' style={{
                            left: `${((stopTime/totalDuration)*100) - 1}%`
                        }}/>
                        <div className='absolute text-[10px] font-medium text-[#54A3F5] -top-4' style={{
                            left: `${((stopTime/totalDuration)*100) - (width >= 1024 ? 1.5 : 4)}%`
                        }}>
                            {formatSeconds(stopTime)}
                        </div>
                    </div>
                </div>
            </div>}
            <div className='px-4 lg:px-6 flex gap-3'>
                <div className='flex w-fit reactour-tilebar'>
                    <div className='flex items-center border border-[#3F6E9C] w-fit p-1.5 rounded-xl cursor-pointer' onClick={handleClick}>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Thumbs_Up_4.png?updatedAt=1689679686265" width={20} height={20} alt="" />
                    </div>
                    <div className='flex items-center border border-[#3F6E9C] w-fit p-1.5 rounded-xl ml-2 cursor-pointer'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/View_1001.png?updatedAt=1689680163489" width={20} height={20} alt="" />
                        <p className='text-[10px] ml-1 font-medium'>{randomDigit?.toFixed(1)+ 'k'}</p>
                    </div>
                    <div className='flex items-center border border-[#3F6E9C] w-fit p-1.5 rounded-xl ml-2 cursor-pointer' onClick={() => setShowReportModal(true)}>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Flag_2.png?updatedAt=1689680060840" width={20} height={20} alt="" />
                        <p className='text-[10px] ml-1 font-medium'>Report</p>
                    </div>
                    <CommentModal
                        showCommentModal={showCommentModal}
                        setShowCommentModal={setShowCommentModal}
                    />
                    <ReportModal
                        showReportModal={showReportModal} 
                        setShowReportModal={setShowReportModal}
                        user_id={uid}
                        lessonDetails={lessonDetails}
                        course_name={subject_name}
                    />
                </div>
                <div className={`bg-secondary_background p-2 rounded-xl flex items-center gap-2 ${(startTime === 0 && stopTime === totalDuration) || (startTime === 0 && stopTime === 0) ? '' : 'cursor-pointer'} reactour-video-duration`} onClick={handleShowTimeLine}>
                    <img src="https://assets.learntube.ai/files/Lead%20Generation/Component%202.png?updatedAt=1713426807476" width={20} height={20} alt="" />
                    {(startTime === 0 && stopTime === totalDuration) || (startTime === 0 && stopTime === 0) ? <p className='text-[10px]'>Watch Full Video</p> : <p className='text-[10px]'>{time} min <img src="https://assets.learntube.ai/files/Lead%20Generation/Polygon%201.png?updatedAt=1713428230818" width={8} height={8} alt="" className='inline' /></p>}
                </div>
            </div>
        </>
    )
}

export default LikeCommentViewReport